module.exports = __webpack_public_path__ + "static/media/logo.839b9dd2.mp4";